import { MasterConfigContext } from "@/context/MasterConfigContext";
import {
  apstagBidCallback,
  createApsSlotsRosDesktop,
  createApsSlotsRosMobile,
  requestBiddingFromPWT,
} from "@/utils/ads";
import { createFaqSchema, createStatics } from "@/utils/boards";
import dynamic from "next/dynamic";

import { useContext, useEffect, useMemo } from "react";
const NewsGrid1 = dynamic(() => import("@/component/NewsGrid/NewsGrid1"));
const HeadTag = dynamic(() => import("@/component/SeoTags/HeadTag"));
const GTMScript = dynamic(() => import("@/component/Ads/GTMScript"));
const Breadcrumb = dynamic(() => import("@/component/Breadcrumb"));
const ItemsList = dynamic(() => import("@/component/SeoTags/ItemsList"));
const BoardsInfoForm = dynamic(() =>
  import("@/component/BoardResults/BoardsInfoForm"),
  {
    loading: () => <p>Loading Form...</p>,
    ssr: false,
  }
);

const BoardsFAQSchema = dynamic(() =>
  import("@/component/SeoTags/BoardsFAQSchema")
);
const AdSlot300x250 = dynamic(() => import("@/component/Ads/AdSlot300x250"));
const AdSlot728x90 = dynamic(() => import("@/component/Ads/AdSlot728x90"));

const BreadcrumbSchema = dynamic(() =>
  import("@/component/SeoTags/BreadcrumbSchema")
);
const WebpageSchema = dynamic(() =>
  import("@/component/SeoTags/WebpageSchema")
);

import SVG from "react-inlinesvg";

const BoardsResultWidget = ({
  isMobileDevice = false,
  topicNewsListData = null,
  tenthResult = false,
  faqData = null,
  stateKey = "Bihar",
}) => {
  const masterConfig = useContext(MasterConfigContext);
  const boardsKeys = masterConfig["boards_result"];
  const declaredKeys = masterConfig["declaredBoards_2025"];
  const showIframe = (tenthResult ? boardsKeys.showIframe10 : boardsKeys?.showIframe12) && stateKey == boardsKeys.stateKey;
  const showForm = (tenthResult ? boardsKeys.show10form : boardsKeys.show12form);
  const statics = useMemo(() => createStatics(stateKey, tenthResult), [stateKey, tenthResult]);
  const faqSchema = useMemo(() => createFaqSchema(stateKey, tenthResult), [stateKey, tenthResult]);

  const declaredResult = useMemo(() => {
    return declaredKeys?.find((item) => item.stateKey === stateKey) || null;
  }, [declaredKeys, stateKey]);

  const iframeSrc = tenthResult
    ? declaredResult?.iframe10 || boardsKeys?.result10url
    : declaredResult?.iframe12 || boardsKeys?.result12url;

  const {
    breadCrumbs,
    title,
    description,
    keywords,
    canonical,
    imgSrc,
    imgSrcMobile,
    h1,
    info,
    stateText,
    segment,
    content
  } = statics;


  useEffect(() => {
    setTimeout(() => {
      window.googletag = window.googletag || { cmd: [] };

      if (window.screen.width < 900) {
        googletag.cmd.push(function () {
          googletag.destroySlots();
          googletag
            .defineSlot(
              "/1007232/News_tak_Mobile_ROS_ATF_300x250",
              [300, 250],
              "div-gpt-ad-1659434453897-0"
            )
            .addService(googletag.pubads());

          googletag
            .defineSlot(
              "/1007232/News_tak_Mobile_ROS_BTF_300x250",
              [300, 250],
              "div-gpt-ad-1659435474737-0"
            )
            .addService(googletag.pubads());
          googletag
            .defineSlot(
              "/1007232/News_tak_Mobile_ROS_Bottom_320x50",
              [320, 50],
              "div-gpt-ad-1659435612077-0"
            )
            .addService(googletag.pubads());

          // googletag.pubads().enableSingleRequest();
          googletag.pubads().disableInitialLoad();
          googletag.enableServices();
          requestBiddingFromPWT();
          // Object.keys(keyBindings).forEach((key) => {
          //   googletag.pubads().setTargeting(key, keyBindings[key]);
          // });
          googletag.cmd.push(function () {
            var INTERSTITIALAd = googletag
              .defineOutOfPageSlot(
                "/1007232/News_tak_Mobile_ROS_Mweb_Interstitial",
                googletag.enums.OutOfPageFormat.INTERSTITIAL
              )
              .addService(googletag.pubads());

            googletag.display(INTERSTITIALAd);
          });
        });
      } else {
        googletag.cmd.push(function () {
          googletag.destroySlots();
          googletag
            .defineSlot(
              "/1007232/News_tak_Desktop_ROS_ATF_728x90",
              [728, 90],
              "div-gpt-ad-1659424515060-0"
            )
            .addService(googletag.pubads());
          googletag
            .defineSlot(
              "/1007232/News_tak_Desktop_ROS_ATF_300x250",
              [300, 250],
              "div-gpt-ad-1707804176041-1"
            )
            .addService(googletag.pubads());

          googletag
            .defineSlot(
              "/1007232/News_tak_Desktop_ROS_BTF_728x90",
              [728, 90],
              "div-gpt-ad-1659425743360-0"
            )
            .addService(googletag.pubads());

          // googletag.pubads().enableSingleRequest();
          googletag.pubads().disableInitialLoad();
          googletag.enableServices();
          requestBiddingFromPWT();
          // Object.keys(keyBindings).forEach((key) => {
          //   googletag.pubads().setTargeting(key, keyBindings[key]);
          // });
        });
      }
      apstag?.fetchBids(
        {
          slots:
            window.screen.width < 900
              ? createApsSlotsRosMobile({ mtf2: false, mtf3: false })
              : createApsSlotsRosDesktop({ mtf2: false, mtf3: false }),
          timeout: 2e3,
        },
        apstagBidCallback
      );
    }, 10);
  }, []);

  return (
    <section className="w-full">
      <HeadTag
        title={title}
        description={description}
        keywords={keywords}
        canonicalUrl={process.env.NEXT_PUBLIC_WEBSITE_URL + canonical}
        noAuthorTag={false}
        image={topicNewsListData?.seo_detail?.og_image}
        lcpImage={isMobileDevice ? imgSrcMobile : imgSrc}
      />
      <GTMScript isElection={true} />
      <WebpageSchema
        title={title}
        description={description}
        keywords={keywords}
        canonicalUrl={process.env.NEXT_PUBLIC_WEBSITE_URL + canonical}
      />
      <BreadcrumbSchema breadcrumbList={breadCrumbs} />

      <BoardsFAQSchema
        tenthResult={tenthResult}
        schemaValues={faqSchema.schema}
      />

      <ItemsList data={topicNewsListData?.content} />
      <Breadcrumb breadcrumbList={breadCrumbs} />

      <div className="mx-auto px-4">
        <AdSlot728x90
          divId="div-gpt-ad-1659424515060-0"
          minWidth="720px"
          minHeight="90px"
        />
      </div>
      <div className="mx-4 px-4">
        <AdSlot300x250
          divId="div-gpt-ad-1659434453897-0"
          minWidth="300px"
          minHeight="250px"
        />
      </div>

      <div>
        {/* {!isMobileDevice ? ( */}
        <div className="hidden md:block">
          <div className="relative lg:h-[120px] md:h-[100px] w-full">
            <img
              src={imgSrc}
              alt="Boards"
              width={900}
              height={130}
              // layout="intrinsic"
              fetchpriority="high"
              loading="eager"
              className="w-full -px-4 my-4 z-0 h-auto"
            />

            <div className="absolute top-[30%] left-[3%] flex items-start gap-2 z-10">
              <span className="text-white font-semibold text-5xl">
                {stateText}
              </span>
              <div className=" flex flex-col items-center gap-0 font-semibold">
                <span className="text-white text-md -mb-1">
                  {tenthResult ? "10th बोर्ड" : "12th बोर्ड"}
                </span>
                <span className="text-yellow-300 text-xl">2025</span>
              </div>
              <span className="text-white font-semibold text-5xl">
                रिजल्‍ट
              </span>
            </div>

          </div>
          <div className="px-3">
            <div className="flex my-4 gap-2 items-center">
              <span className="bg-[#CC0000] w-2 h-4"></span>

              {!isMobileDevice && <h1 className="text-xl font-semibold">{h1}</h1>}
            </div>

            {((tenthResult ? declaredResult?.iframe10 : declaredResult?.iframe12) || showIframe) ? (
              <div className="border-y-8 border-[#2525260D] py-4">
                <p className="text-[#323232] text-md">{info}.</p>
                <iframe
                  src={
                    iframeSrc
                  }
                  width="100%"
                  height="1000"
                  style={{ border: "none" }}
                  allowFullScreen
                  className="my-8"
                ></iframe>
              </div>
            ) : showForm ? (
              <div className="w-full text-center my-16">
                <BoardsInfoForm
                  onBanner={false}
                  tenthForm={tenthResult}
                  stateKey={stateKey}
                  segment={segment}
                />
              </div>
            ) : (
              <div className="w-full text-center my-16">
                <p className="text-primary font-semibold text-2xl">Coming Soon</p>
              </div>)}
          </div>
        </div>
        {/* ) : ( */}
        <div className="md:hidden">
          <div className="relative sm:h-[280px] lg:h-[160px] md:h-[160px] w-full">
            <img
              src={imgSrcMobile}
              alt="Boards"
              width={900}
              height={200}
              fetchpriority="high"
              loading="eager"
              className="w-full my-4 z-0 min-h-full max-h-full "
            />
            <div className="absolute top-8 left-6 flex flex-col items-start gap-0 z-10 font-semibold">
              <span className="text-yellow-300 text-lg">2025</span>
              {stateKey == "up" || stateKey == "mp" ? (
                <div className="flex items-start gap-2">
                  <span
                    className={`text-white ${stateKey == "up" || stateKey == "mp"
                      ? "text-5xl"
                      : "text-4xl"
                      }`}
                  >
                    {stateText}
                  </span>

                  <div className="text-white font-medium flex flex-col items-start text-md -mb-1">
                    {tenthResult ? "10th बोर्ड" : "12th बोर्ड"}
                    <span>रिजल्‍ट</span>
                  </div>
                </div>
              ) : (
                <div className="flex flex-col items-start gap-0">
                  <span
                    className={`text-white ${stateKey == "up" || stateKey == "mp"
                      ? "text-5xl"
                      : "text-4xl"
                      }`}
                  >
                    {stateText}
                  </span>

                  <div className="text-white font-medium flex items-start gap-1 text-md -mb-1">
                    {tenthResult ? "10th बोर्ड" : "12th बोर्ड"}
                    <span>{"रिजल्‍ट"}</span>
                  </div>
                </div>
              )}
            </div>

          </div>
          <div className="px-3">
            <div className="flex my-4 gap-2 items-center">
              <span className="bg-[#CC0000] w-2 h-4 -mt-1"></span>

              {isMobileDevice && <h1 className="text-xl font-semibold">{h1}</h1>}
            </div>

            {(declaredResult || showIframe) ? (
              <div className="border-y-8 border-[#2525260D] py-4">
                <p className="text-[#323232] text-md">{info}.</p>
                <iframe
                  src={
                    iframeSrc
                  }
                  width="100%"
                  height="1000"
                  style={{ border: "none" }}
                  allowFullScreen
                  className="my-8"
                ></iframe>
              </div>
            ) : showForm ? (
              <div className="w-full text-center my-16">
                <BoardsInfoForm
                  onBanner={false}
                  tenthForm={tenthResult}
                  stateKey={stateKey}
                  segment={segment}
                />
              </div>
            ) : (
              <div className="w-full text-center my-16">
                <p className="text-primary font-semibold text-2xl">Coming Soon</p>
              </div>
            )}
          </div>
        </div>
        {/* )} */}
        {/* news list */}
        {topicNewsListData &&
          topicNewsListData?.content?.length > 0 &&
          boardsKeys?.showNewsList && (
            <section className="px-3">
              <div className="flex items-center justify-between mt-8">
                <h2 className="flex mb-2 gap-2 items-center">
                  <span className="bg-[#CC0000] w-2 h-4"></span>
                  <span className="text-xl font-semibold">शिक्षा न्यूज</span>
                </h2>
                <a href="/education">
                  <span className="flex items-center text-md">
                    और देखें
                    <SVG
                      className="w-6 h-6 inline ml-2  mt-[-2px]"
                      src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/rightArrowRound.svg"
                    />
                  </span>
                </a>
              </div>
              <div className="text-16">
                <NewsGrid1
                  newsData={topicNewsListData || null}
                  showLiveVideo={false}
                  showAd={false}
                  isLCP={
                    boardsKeys?.showIframe10 || boardsKeys?.showIframe12
                      ? false
                      : true
                  }
                  isMobileDevice={isMobileDevice}
                  liveVideoData={null}
                  isResultsPage={true}
                />
              </div>
            </section>
          )}

        {/* description  */}
        <h2 className="px-3 flex mt-12 mb-2 gap-2 items-start">
          <span className="bg-[#CC0000] w-2 h-4"></span>
          <span className="text-xl font-semibold -mt-1">
            {tenthResult
              ? stateText + " बोर्ड 10वीं परीक्षा परिणाम"
              : stateText + " बोर्ड 12वीं परीक्षा परिणाम"}
          </span>
        </h2>
        <div className="px-4 text-[#323232] text-sm text-left" dangerouslySetInnerHTML={{ __html: content }}></div>

        {/* faqs  */}

        {boardsKeys?.showFAQ && faqData && (
          <div className="px-3">
            <h2 className="flex mt-8 mb-2 gap-2 items-start">
              <span className="bg-[#CC0000] w-2 h-4"></span>
              <span className="text-xl font-semibold -mt-1">
                {tenthResult
                  ? stateText + " बोर्ड 10वीं परिणाम से जुड़े सवाल जवाब (FAQs)"
                  : stateText + " बोर्ड 12वीं परिणाम से जुड़े सवाल जवाब (FAQs)"}
              </span>
            </h2>
            <section className="mt-4 flex flex-col gap-4 text-gray-500 text-md font-extralight">
              <p
                className={`${isMobileDevice ? "custom-mb-break" : ""}`}
                dangerouslySetInnerHTML={{
                  __html: `${faqData?.content?.description_short}`,
                }}
              />
            </section>
          </div>
        )}
      </div>
      <div className="mx-4 px-4">
        <AdSlot300x250
          divId="div-gpt-ad-1659435474737-0"
          minWidth="300px"
          minHeight="250px"
        />
        <AdSlot728x90
          divId="div-gpt-ad-1659425743360-0"
          minWidth="720px"
          minHeight="90px"
        />
      </div>
    </section>
  );
};

export default BoardsResultWidget;
